/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetTagFamilyTags200ResponseAllOfData } from './GetTagFamilyTags200ResponseAllOfData';
import {
    GetTagFamilyTags200ResponseAllOfDataFromJSON,
    GetTagFamilyTags200ResponseAllOfDataFromJSONTyped,
    GetTagFamilyTags200ResponseAllOfDataToJSON,
} from './GetTagFamilyTags200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetTagFamilyTags200Response
 */
export interface GetTagFamilyTags200Response {
    /**
     * 
     * @type {GetTagFamilyTags200ResponseAllOfData}
     * @memberof GetTagFamilyTags200Response
     */
    data: GetTagFamilyTags200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetTagFamilyTags200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetTagFamilyTags200Response interface.
 */
export function instanceOfGetTagFamilyTags200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetTagFamilyTags200ResponseFromJSON(json: any): GetTagFamilyTags200Response {
    return GetTagFamilyTags200ResponseFromJSONTyped(json, false);
}

export function GetTagFamilyTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTagFamilyTags200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetTagFamilyTags200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetTagFamilyTags200ResponseToJSON(value?: GetTagFamilyTags200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetTagFamilyTags200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

